<template>
  <b-col class="" v-if="items.length">
    <b-row>
      <b-col cols="12">
        <headerPdf title="مشخصات همسر" />
      </b-col>
    </b-row>
    <b-row class="my-2" v-for="(item, i) in renderedItems" :key="i">
      <b-col cols="12" class="text-center d-flex mb-3">
        <div class="information-pro mr-main-4">
          {{ `${item.fullName} - ${item.mobile}` }}
        </div>
        <div class="information-pro ml-5">
          {{ `${item.fullPath} - ${item.zoneNumber}` }}
        </div>
      </b-col>
      <b-col cols="3">
        <eachItemPdf
          :title="$lang.national_code"
          :subTitle="item.nationalCode"
        />
      </b-col>
      <b-col cols="2">
        <eachItemPdf :title="$lang.birth_date" :subTitle="item.birthDate" />
      </b-col>
      <b-col cols="2">
        <eachItemPdf
          :title="$lang.date_marriage"
          :subTitle="item.marriageDate"
        />
      </b-col>
      <b-col cols="2">
        <eachItemPdf
          :title="$lang.date_separation_death"
          :subTitle="item.separationDate"
        />
      </b-col>
      <b-col cols="3">
        <eachItemPdf :title="$lang.date_death" :subTitle="item.deathDate" />
      </b-col>
      <b-col>
        <div class="quote">
          {{ item.description }}
        </div>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import headerPdf from "../headerPdf.vue";
import eachItemPdf from "../eachItemPdf.vue";
import { pathOr } from "ramda";

export default {
  name: "WifeInfo",
  components: {
    headerPdf,
    eachItemPdf,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    renderedItems() {
      return this.items.map((item) => {
        const name = pathOr("", ["name"], item);
        const family = pathOr("", ["family"], item);
        return {
          fullName: `${name} ${family}`,
          mobile: pathOr("", ["mobile"], item),
          fullPath: pathOr("", ["full_path"], item),
          zoneNumber: pathOr("", ["zone_number"], item),
          nationalCode: pathOr("", ["national_code"], item),
          birthDate: pathOr("", ["birth_date"], item),
          marriageDate: pathOr("", ["marriage_date"], item),
          separationDate: pathOr("", ["separation_date"], item),
          deathDate: pathOr("", ["death_date"], item),
          description: pathOr("", ["description"], item),
        };
      });
    },
  },
  methods: { pathOr },
};
</script>

<style lang="scss" scoped>
.information-pro {
  font-size: 14px;
  font-weight: 500;
  color: #282c52;
}

.mr-main-4 {
  margin: 0 0 0 31px;
}
</style>
